import { Icon, forwardRef } from "@chakra-ui/react";
import * as React from "react";
export const SvgGeminiLogoIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(Icon, { ref, color: "foreground.secondary", fill: "none", focusable: "false", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 1c.55 3.74 3.26 6.45 7 7-3.74.55-6.45 3.26-7 7-.55-3.74-3.26-6.45-7-7 3.74-.55 6.45-3.26 7-7z", fill: "#3186FF" }));
});
export default SvgGeminiLogoIcon;
